class BaseMiddleware {
  handle (from, to, next, args) {
    return next();
  }
}

export default BaseMiddleware;
